import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import BackButton from 'components/ui/BackButton';
import Flex from 'components/ui/Flex';
import Text from 'components/ui/Text';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';

type ErrorDisplayProps = {
    errorMessage: string | null;
    onBack?: () => void;
    title?: string;
    icon?: IconProp;
};

const ErrorDisplay: React.FC<ErrorDisplayProps> = ({ errorMessage, onBack, title, icon }) => {
    const { t } = useTranslation();
    return (
        <StyledFlex
            $grow={1}
            justify="center"
            gap="1rem"
            className="no-orders"
            align="center"
            column
            $hasBack={!!onBack}
        >
            {onBack && (
                <ButtonWrapper>
                    <BackButton onBack={onBack} label={t('back')} />
                </ButtonWrapper>
            )}
            {icon && <FontAwesomeIcon className="mt-1" icon={icon} size="3x" />}
            {title && (
                <Text className="mt-1 mb-1" as="h3">
                    {title}
                </Text>
            )}
            <Text className="mt-0 mb-3" as="p">
                {errorMessage}
            </Text>
        </StyledFlex>
    );
};

export default ErrorDisplay;

const StyledFlex = styled(Flex)<{ $hasBack?: boolean }>`
    padding: 1rem;
    background-color: ${({ theme, $hasBack }) => $hasBack && theme.colors.fillWhite};
    ${({ theme, $hasBack }) => $hasBack && `border: 1px solid ${theme.colors.fillWhite}`};
    width: 100%;
    border-radius: var(--radius);
`;

const ButtonWrapper = styled(Flex)`
    align-self: flex-start !important;
`;
